<template>
  <img src="@/assets/img/logo.svg" alt="logo" class="logo" />
</template>

<script>
import { Component, Vue } from "vue-property-decorator";

@Component
export default class Logo extends Vue {}
</script>
<style lang="scss" scoped>
.logo {
  width: 11rem;
  height: 4.8rem;
}
</style>
